export default __webpack_public_path__ + "static/media/IkonTjekDinPension.2d34a089.svg";